








































































































































































































































import { vxm } from '../store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OtpValidationToken } from '../models/userdata/otptoken';
import RegistrationCard from './Registration/Card.vue';
import CardHeader from './Registration/Header.vue';
import { VerificationError } from '@/models/userdata/verificationerror';
import Container from './Registration/Container.vue';

@Component({
  name: 'OtpVerfication',
  components: {
    Container,
    RegistrationCard,
    CardHeader,
  },
})
export default class OtpVerfication extends Vue {
  private otpToken: OtpValidationToken = new OtpValidationToken();
  private phoneEdit: boolean = false;
  private phone: string = '';
  private phoneNumberValid: boolean = false;
  private mobileNumber: string = '';
  $wlToastr: any;
  private phoneNumber: string = '';
  private errors = new VerificationError();
  private numberErrors = {
    phone: '',
  };
  @Prop({ default: '' }) phoneNumberFromApi;

  updateVerificationOtpPhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    // this.phone = '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.phone = event.nationalNumber;
    this.phoneNumberValid = event.isValid;
  }

  editPhone() {
    if (!this.phone && this.phoneNumberFromApi) {
      this.phone = this.phoneNumberFromApi.replace(/\+\d+\s/, '');
    }
    this.phoneEdit = true;
  }

  submitChangePhone() {
    if (!this.phoneNumberValid) {
      this.$wlToastr('error', 'Please enter valid number', 'Phone number');
      return;
    }
    let companycode = vxm.jobs.BrandingInfo.companycode;
    let phoneNumber = this.phone;
    let countryCode = '+1';
    countryCode = encodeURIComponent(countryCode);
    let email = encodeURIComponent(
      vxm.users.myUserProfile.email || this.$route.query.userid + '',
    );
    const changeNumberCount = '1';
    let url = `/wl-sso-sec-svc/api/user/changeNumber?companycode=${companycode}&email=${email}&phone=${phoneNumber}&changeNumberCount=${changeNumberCount}&countrycode=${countryCode}`;
    vxm.users.changeNumber(url).then((resp) => {
      if (resp.status === 'success') {
        this.phoneEdit = false;
        this.phoneNumber = resp.phone;
        this.$wlToastr(
          'info',
          this.$t('new-verification-code-sent'),
          this.$t('changenumber.toast.title'),
        );
      } else {
        const errorMessage = this.$wlToastr(
          'error',
          this.$t('ph-number-change-err-msg'),
          this.$t('changenumber.toast.title'),
        );
      }
    });
  }

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }
  get getOtpToken(): OtpValidationToken {
    return this.otpToken;
  }

  mounted() {
    this.phoneNumber = vxm.users.myUserProfile.phoneNum;
    this.phone = this.phoneNumber.replace(/\+\d+\s/, '');
  }

  get applicationName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME');
  }

  getCompanyCountryCode(): string {
    return vxm.jobs.getCompanyCountryCode;
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  onContinue(otpToken) {
    this.$emit('continue', otpToken);
  }

  onSkip() {
    this.$emit('skip');
  }
  onResend() {
    this.$emit('resend');
  }
}
